import { ChangeEvent } from 'react'

type ReducerActions<T extends AnyObject> = UpdateActions<T> | InitAction<T>
export const makeActionCreator = <ActionTypes extends AnyObject>() => {
  return <Prop extends keyof ActionTypes & string>(
    prop: Prop,
    payload: ActionTypes[Prop]
  ) => {
    return {
      type: `update_${prop}` as const,
      payload
    } as UpdateActions<ActionTypes>
  }
}

export const makeReducer = <T extends AnyObject>() => {
  return (state: Tracked<T>, action: ReducerActions<T>) => {
    if (action.type === 'init') {
      return { ...(action as InitAction<T>).payload, isChanged: false }
    }
    if (action.type.startsWith('update_')) {
      const [_, prop] = action.type.split('_')
      return { ...state, [prop]: action.payload, isChanged: true }
    }
    return state
  }
}
export const createInitAction = <T extends AnyObject>(setTo: T) =>
  ({
    type: 'init',
    payload: setTo
  } satisfies InitAction<T>)

// This makes sure TS understands all of these functions are operating on the same type
export const setUpReducer = <T extends AnyObject>() => {
  const reducer = makeReducer<T>()
  const initReducerState = (state: T) => ({
    ...state,
    isChanged: false
  })
  const initActionCreator = (setTo: T) =>
    ({
      type: 'init',
      payload: setTo
    } as const)
  const updateActionCreator = makeActionCreator<T>()
  return {
    reducer,
    initState: initReducerState,
    initActionCreator,
    updateActionCreator
  }
}

export const changeEventToNumber = (
  e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>
) => {
  return Number(e.currentTarget.value)
}
export const changeEventToBool = (e: ChangeEvent<HTMLInputElement>) => {
  return e.currentTarget.checked
}
export const changeEventToString = (e: ChangeEvent<HTMLInputElement>) => {
  return e.currentTarget.value
}
